import React from "react";
import { get, noop } from "lodash";

import { formatDateToMMDDYYYYSlashhhmm } from "@tvg/formatter/dates";
import { infoOutline } from "../../_static/Icons/icons";
import Icon from "../../_static/Icons";
import buildColor from "../../_static/ColorPalette";
import {
  Container,
  MethodName,
  MessageContainer,
  LeftMessageWrapper
} from "./styled-components";
import Button from "../../_atom/Buttons/button";
import Text from "../../_atom/Text";

const blockButton = (callback, blockMessage) => (
  <Button
    qaLabel="block-button"
    type="secondary"
    size="default"
    onClick={() => callback(true)}
    optionalData="openRGModal"
  >
    {blockMessage}
  </Button>
);

const renderUnblockDate = (date, blockLiftedMessage, device) =>
  date && (
    <MessageContainer device={device}>
      <LeftMessageWrapper device={device}>
        <Icon
          icon={infoOutline}
          size={10}
          qaLabel="InfoIcon"
          color={buildColor("orange", "500")}
        />
        <Text color={buildColor("orange", "500")}>{blockLiftedMessage}</Text>
      </LeftMessageWrapper>
      <Text color={buildColor("orange", "500")}>
        {formatDateToMMDDYYYYSlashhhmm(date)}
      </Text>
    </MessageContainer>
  );

const onBlockButtonClick = ({
  name,
  blockButtonCallback,
  setCurrentMethod,
  setCurrentCode,
  code
}) => {
  setCurrentMethod(name);
  setCurrentCode(code);
  blockButtonCallback(name, code);
};

export const genQaLabel = (name, blocked) =>
  `rg-${blocked ? "blocked" : "block"}-row-${name
    .toLowerCase()
    .trim()
    .replace(/ /g, "-")}`;

const FundingMethod = (props) => (
  <Container
    hasMessage={get(props, "isBlocked", false)}
    device={props.device}
    data-qa-label={genQaLabel(
      get(props, "name", ""),
      get(props, "isBlocked", false)
    )}
  >
    <MethodName device={props.device}>{get(props, "name", "")}</MethodName>
    {get(props, "isBlocked", false)
      ? renderUnblockDate(
          get(props, "unblockDate", ""),
          props.blockLiftedMessage,
          props.device
        )
      : blockButton(() => onBlockButtonClick(props), props.blockMessage)}
  </Container>
);

FundingMethod.defaultProps = {
  isBlocked: false,
  name: "",
  device: "mobile",
  blockLiftedMessage: "",
  blockMessage: "",
  unblockDate: null,
  blockButtonCallback: noop,
  setCurrentMethod: noop,
  setCurrentCode: noop
};

export default React.memo(FundingMethod);
